import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-curve-bottom",
  "use": "icon-curve-bottom-usage",
  "viewBox": "0 0 300 31.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 300 31.5\" id=\"icon-curve-bottom\"><title>curve-bottom</title><path d=\"M0,.5a379.78,379.78,0,0,0,154.5,31A379.18,379.18,0,0,0,300,.5V32H0Z\" transform=\"translate(0 -0.5)\" /><path d=\"M188,55\" transform=\"translate(0 -0.5)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol